module.exports = __webpack_public_path__ + "img/icon-hero-tw.89110365.png";